export default "/_next/static/media/Hotel_Booking-600x450.7578bc40f0d3f2a16c447dc97969a131.png";